/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-08-17 10:37:30
 * @LastEditTime: 2022-01-08 14:28:27
 * @FilePath: /teacher-h5/src/store/modules/common.js
 */
const state = {
  baseData: {},
  periodList: [],
  classCycleList: [],
  yearList: [],
  timeIntervalList: [],
  semesterList: [],
  linkTypeList: [],
  groupStudentTypeList: [],
  teacherOperateTypeList: [],
  classCorrectTypeList: [],
  classCorrectOptTypeList: [],
  activePeriod: -2,
  activeClassCycle: -1,
  activeYear: -1,
  activeTimeInterval: -1,
  activeSemester: -1,
  activeLinkType: -1,
  activeGroupStudentType: -1,
  activeTeacherOperateType: -1,
  gradeList: [],
  subjectList: [],
  groupMsgArr: [],
  activeGradeId: -1,
  isFullScreen: false, // 全屏
  scalingNum: 100, // 缩放比例
  jurisdictionType: [],
  showChromeTip: 'undefined',
  globalSpinning: false
}

// 自定义改变state初始值的方法
const mutations = {
  setGlobalSpinning(state, bool) {
    state.globalSpinning = bool
  },
  setShowChromeTip(state, bool) {
    state.showChromeTip = bool
  },
  setIsFullScreen(state, bool) {
    state.isFullScreen = bool
  },
  setGroupMsgArr(state, arr) {
    state.groupMsgArr = arr
  },
  setBaseData(state, baseData) {
    state.baseData = JSON.parse(JSON.stringify(baseData))
  },
  setPeriodList(state, data) {
    data.unshift({
      id: -2,
      name: '全部'
    })
    state.periodList = data
    state.activePeriod = data[0].id
  },
  setClassCycleList(state, data) {
    data.unshift({
      id: -1,
      name: '全部'
    })
    state.classCycleList = data
    state.activeClassCycle = data[0].id
  },
  setYearList(state, data) {
    const yearList = (data || []).map((item, index) => ({
      id: index,
      name: item
    }))
    yearList.unshift({
      id: -1,
      name: '全部'
    })
    state.yearList = yearList
    state.activeYear = yearList[0].id
  },
  setTimeIntervalList(state, data) {
    data.unshift({
      id: -1,
      name: '全部'
    })
    state.timeIntervalList = data
    state.activeTimeInterval = data[0].id
  },
  setSemesterList(state, data) {
    const semesterList = (data || []).map((item, index) => ({
      id: index,
      name: item
    }))
    semesterList.unshift({
      id: -1,
      name: '全部'
    })
    state.semesterList = semesterList
    state.activeSemester = semesterList[0].id
  },
  setLinkTypeList(state, data) {
    data.unshift({
      id: -1,
      name: '全部'
    })
    state.linkTypeList = data
    state.activeLinkType = data[0].id
  },
  setGroupStudentTypeList(state, data) {
    data.unshift({
      id: -1,
      name: '全部'
    })
    state.groupStudentTypeList = data
    state.activeGroupStudentType = data[0].id
  },
  setTeacherOperateTypeList(state, data) {
    data.unshift({
      id: -1,
      name: '全部'
    })
    state.teacherOperateTypeList = data
    state.activeTeacherOperateType = data[0].id
  },
  setClassCorrectTypeList(state, data) {
    state.teacherOperateTypeList = data
  },
  setClassCorrectOptTypeList(state, data) {
    state.teacherOperateTypeList = data
  },
  setJurisdictionType(state, data) {
    state.jurisdictionType = data
  },

  setActivePeriod(state, data) {
    state.activePeriod = data
  },
  setActiveClassCycle(state, data) {
    state.activeClassCycle = data
  },
  setActiveYear(state, data) {
    state.activeYear = data
  },
  setActiveTimeInterval(state, data) {
    state.activeTimeInterval = data
  },
  setActiveSemester(state, data) {
    state.activeSemester = data
  },
  setActiveLinkType(state, data) {
    state.activeLinkType = data
  },
  setActiveGroupStudentType(state, data) {
    state.activeGroupStudentType = data
  },
  setActiveTeacherOperateType(state, data) {
    state.activeTeacherOperateType = data
  },
  setActiveGradeId(state, data) {
    state.activeGradeId = data
  },
  setScalingNum(state, data) {
    if (!data || isNaN(data)) return
    const scaling = data > 100 ? 1 : Number(data) / 100
    document.body.style.zoom = scaling
    state.scalingNum = data > 100 ? 100 : data
    // 缓存监课页面用户操作的缩放比例
    if (window.location.href.indexOf('supervisionCourse/list') !== -1) {
      sessionStorage.setItem('userOperationNum', state.scalingNum)
    }
  }
}

// 自定义触发mutations里函数的方法
const actions = {
}

const getters = {
  // 未处理过的基础数据
  baseData: state => state.baseData,
  // 期次:十二个期次
  periodList: state => state.periodList,
  // 周期:周一至周日
  classCycleList: state => state.classCycleList,
  // 年份
  yearList: state => state.yearList,
  // 时段:上午、下午、晚上
  timeIntervalList: state => state.timeIntervalList,
  // 学期:春暑秋寒
  semesterList: state => state.semesterList,
  // 环节:课本历练、双色笔记、日积月累、融会贯通
  linkTypeList: state => state.linkTypeList,
  // 被打回订正、被打回待订正、评优次数
  groupStudentTypeList: state => state.groupStudentTypeList,
  // 打回订正、过关、优秀
  teacherOperateTypeList: state => state.teacherOperateTypeList,
  // 待批改、被打回、优秀
  classCorrectTypeList: state => state.classCorrectTypeList,
  // 待批改、未提交、已批改
  classCorrectOptTypeList: state => state.classCorrectOptTypeList,

  activePeriod: state => state.activePeriod,
  activeClassCycle: state => state.activeClassCycle,
  activeYear: state => state.activeYear,
  activeTimeInterval: state => state.activeTimeInterval,
  activeSemester: state => state.activeSemester,
  activeLinkType: state => state.activeLinkType,
  activeGroupStudentType: state => state.activeGroupStudentType,
  activeTeacherOperateType: state => state.activeTeacherOperateType,
  // 班级
  gradeList: state => state.gradeList,
  // 学科
  subjectList: state => state.subjectList,
  groupMsgArr: state => state.groupMsgArr,
  isFullScreen: state => state.isFullScreen,
  scalingNum: state => state.scalingNum,
  jurisdictionType: state => state.jurisdictionType,
  showChromeTip: state => state.showChromeTip,
  globalSpinning: state => state.globalSpinning
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
